import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://api.antikbet.dev:1881/', // Backend URL
});

// İSTEK ATARKEN: Token ekle
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// CEVAP GELİRKEN: Yetki kontrolü yap (YENİ EKLENEN KISIM)
axiosInstance.interceptors.response.use(
  (response) => {
    // Cevap başarılıysa (200-299 arası) olduğu gibi döndür
    return response;
  },
  (error) => {
    // Eğer sunucu 401 (Unauthorized) hatası dönerse
    if (error.response && error.response.status === 401) {
      console.warn("Yetkisiz erişim veya oturum süresi doldu!");
      
      // Localstorage'ı temizle ki App.js redirect etsin
      localStorage.removeItem('token');
      
      // Kullanıcıyı Login sayfasına yönlendir
      window.location.href = '/login'; 
    }
    
    // Hatayı diğer işlemler (catch blokları) için fırlatmaya devam et
    return Promise.reject(error);
  }
);

export default axiosInstance;